{
  "version": 1,
  "asset_id": "f002a933-0386-4d42-8c06-1db540d0d443",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f002a933-0386-4d42-8c06-1db540d0d443/airtechpro-gsc-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f002a933-0386-4d42-8c06-1db540d0d443/airtechpro-gsc-1280.avif",
  "original_filename": "airtechpro-gsc-1280.avif",
  "size": 30211,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:45Z"
}
